export default {
    NAME: "Название",
    NAME_PLACEHOLDER: "Введите название",
    DESCRIPTION: "Описание",
    DESCRIPTION_PLACEHOLDER: "Введите описание",
    REQUIRED_OPTION_EMPTY_MESSAGE: "Поле не заполнено",
    CREATE: "Создать",
    CANCEL: "Отменить"
};
